const sortTypes = {
  ended: [
    {
      label: 'Recently Ended',
      event: {
        key: 'recently_ended',
        label: 'Recently Ended',
        backEndSortType: null,
      },
    },
    {
      label: 'Close to Market Value',
      event: {
        key: 'close_to_market_value',
        label: 'Close to Market Value',
        backEndSortType: 'acv_estimate_delta',
      },
    },
  ],
  live: [
    {
      label: 'Recommended',
      event: {
        key: 'recommended',
        label: 'Recommended',
        backEndSortType: 'recommended',
      },
    },
    {
      label: 'End Time',
      event: {
        key: 'end_time',
        label: 'End Time',
        backEndSortType: null,
      },
    },
  ],
};

export default {
  namespaced: true,
  state: {
    cachedSortSelection: null,
    currentSortSelection: null,
    sortTypes,
  },
  mutations: {
    setCachedSortSelection(state, value) {
      state.cachedSortSelection = value;
    },
    setCurrentSortSelection(state, value) {
      state.currentSortSelection = value;
    },
    setLaneSortTypes(state, sortTypesObj) {
      state.sortTypes = { ...sortTypesObj };
    },
  },
  actions: {
    updateCachedSortSelection({ commit }, value) {
      commit('setCachedSortSelection', value);
    },
    clearSortingFilterSelection({ commit }) {
      commit('setCachedSortSelection', null);
      commit('setCurrentSortSelection', null);
    },
    updateCurrentSortSelection({ commit }, value) {
      commit('setCurrentSortSelection', value);
    },
    updateLaneSortTypes({ commit }, sortTypesObj) {
      commit('setLaneSortTypes', sortTypesObj);
    },
  },
  getters: {
    cachedSortSelection: (state) => state.cachedSortSelection,
    currentSortSelection: (state) => state.currentSortSelection,
    sortTypes: (state) => state.sortTypes,
  },
};
